import { SUPPORTED_LANGUAGES } from "../../ui/common/constants/SupportedLanguages";
import LookupApiService from "@api-services/LookupApiService";
import { getCurrentCulture} from "@utils";
import { BasicLookupModel } from "@api-types";
import { ContextOptions } from "@utils/api-config/types";

class LookupService {
	static async findBetStatuses(context: ContextOptions) {
		var response = await LookupApiService.findLookup(
			"bet-statuses",
			context
		);
		return this.mapLookupResponse(response);
	}

	static async findBetSlipStatuses(filter: ContextOptions) {
		var response = await LookupApiService.findLookup(
			"bet-slip-statuses",
			filter
		);
		return this.mapLookupResponse(response);
	}

	static async findBettingAccountTypes(filter: ContextOptions) {
		var response = await LookupApiService.findLookup(
			"betting-account-types",
			filter
		);
		return this.mapLookupResponse(response);
	}

	static mapLookupResponse(response: BasicLookupModel[]) {
		let result = response.map((el) => ({
			id: el.id,
			abrv: el.abrv,
			name: this.getLocalizedName(el),
		}));
		return result;
	}

	static getLocalizedName(lookupItem: BasicLookupModel) {
		const culture = getCurrentCulture();
		const cultureKey =
			SUPPORTED_LANGUAGES.find((lang) => lang.key == culture)?.keyLong ||
			"en";

		return culture == "en"
			? lookupItem.name
			: // @ts-expect-error
				lookupItem.languageMetadata[cultureKey].name;
	}
}
export default LookupService;
